import { render } from "./promotionalGiveModel.vue?vue&type=template&id=f02934c0"
import script from "./promotionalGiveModel.vue?vue&type=script&lang=js"
export * from "./promotionalGiveModel.vue?vue&type=script&lang=js"

import "./promotionalGiveModel.vue?vue&type=style&index=0&id=f02934c0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__